import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLayout } from '../../contexts/LayoutContext';

const UserFooter = ({ userProfile = null, loading = false }) => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { navCollapsed } = useLayout();

  const handleClick = () => {
    navigate('/app/profile');
  };

  // Get display name from userProfile or fallback to Firebase user
  const displayName = userProfile?.displayName || user?.name || user?.email?.split('@')[0] || 'User';
  
  // Get initials for avatar
  const getInitials = (name) => {
    if (!name) return 'U';
    const words = name.trim().split(/\s+/);
    if (words.length > 1) {
      return words.slice(0, 2).map(word => word[0]).join('').toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  };

  const initials = getInitials(displayName);

  return (
    <div className="user-footer" onClick={handleClick}>
      <div className="user-avatar">
        {initials}
      </div>
      {!navCollapsed && (
        <div className="user-info">
          <div className="user-name">
            {loading ? 'Loading...' : displayName}
          </div>
        </div>
      )}
    </div>
  );
};

UserFooter.propTypes = {
  userProfile: PropTypes.shape({
    displayName: PropTypes.string
  }),
  loading: PropTypes.bool
};

export default UserFooter;